import React, { Children } from 'react';
import {
    CellAlignmentType,
    TableHeaderBox,
} from 'src/ui/components/table/sports/row/hr-gr/event/custom/TableHeaderCell.style';
import { observer } from 'src/utils/mobx-react';

interface TableHeaderCellPropsType {
    /** Text alignment in table cell 'left' | 'center' | 'right'. Default: 'left' */
    align?: CellAlignmentType;
    children?: React.ReactNode;
    className?: string;
    dataTest?: string;
    /** Add extra padding to table cell */
    isWide?: boolean;
    /** Specify mobile size table cell. Default value is flex: 1 1 auto */
    mobileSize?: string;
    /** Specify mobile size table cell. Default value is flex: 1 1 auto */
    tabletSize?: string;
}

/**
 * This component will be used for table headers:
 * - **HR and GR**
 */
export const TableHeaderCell = observer(
    'TableHeaderCell',
    ({
        align,
        children,
        className,
        dataTest,
        isWide,
        mobileSize,
        tabletSize,
    }: TableHeaderCellPropsType): JSX.Element => {
        const hasChildren = Children.count(children) > 0;

        return (
            <TableHeaderBox
                align={align}
                className={className}
                data-test={dataTest ?? 'table-header-cell'}
                isWide={isWide}
                mobileSize={mobileSize}
                tabletSize={tabletSize}
            >
                {hasChildren ? children : null}
            </TableHeaderBox>
        );
    }
);
